'use client';

import { sendErrorToSentry } from '@/utils/sentry';
import Link from 'next/link';
import { useEffect } from 'react';

export default function GlobalError({
  error
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    sendErrorToSentry({ error });
  }, []);

  return (
    <html>
      <body>
        <div className="flex h-[calc(100vh-64px)] flex-col items-center justify-center gap-[30px] md:h-[calc(100vh-80px)]">
          <p className="text-center leading-[30px]">
            申し訳ございません。何らかの問題が発生しました。
            <br />
            時間を置いてから再度お試しください。
          </p>
          <Link
            href="/login"
            className="flex items-center justify-center gap-[5px] text-blue-600 underline"
          >
            ログイン画面へ
          </Link>
        </div>
      </body>
    </html>
  );
}
